import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetAllProfileLogic = () => {
  const [loading, setLoading] = useState(false);
  const [allProfileLogic, setAllProfileLogic] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  const getAllProfileLogic = () => {
    setLoading(true);
    axiosClient
      .get(`SettingProduct/CoddingProfile/GetAllProfileLogic`)
      .then(res => {
        if (res.status === 200) {
          setAllProfileLogic(res.data.value);
        } else {
          enqueueSnackbar(res.data?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };

  return [getAllProfileLogic, loading, allProfileLogic];
};

export default useGetAllProfileLogic;
